import React, { useCallback, useState } from 'react';
import { useTranslation }               from 'react-i18next';
import AccordionArrowIcon               from '../icons/AccordionArrowIcon';

const Accordion = (props) => {
  const {
          children,
          title,
        }     = props;
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(true);

  const toggleAccordion = useCallback(() => {
    setIsOpen((open) => !open);
  }, []);

  if (title === t('client_params')) {
    return null;
  }

  return (
    <div className={'filter_accordion'}>
      <div className={'accordion_title'} onClick={toggleAccordion}>
        <p>{title}</p>
        <AccordionArrowIcon isOpen={isOpen} />
      </div>
      {isOpen && <div className={'accordion_container'}>{children}</div>}
    </div>
  );
};

export default Accordion;
